import { TableCheckbox } from '@dealstack/frontend/shared/components/Table/DefaultTable/TableComponents';
import { DefaultColumnRenderer } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { ColumnRendererProps } from '@dealstack/frontend/shared/components/Table/Table/types';
import classNames from 'classnames';

interface Props {
	areAllInvestorsSelected: (contractId: string) => boolean;
	onContractSelectAll: (contractId: string) => void;
}

export const ColumnRenderer =
	(selectAllProps: Props) =>
	(props: ColumnRendererProps): JSX.Element => {
		if (props.column.id.startsWith('contracts-')) {
			const contractIdArray = props.column.id.split('-');
			contractIdArray.shift();
			const contractId = contractIdArray.join('-');

			return (
				<div className="px-4">
					<div className="flex items-center pb-1 px-2 font-bold pt-1" style={props.style}>
						<TableCheckbox
							checked={selectAllProps.areAllInvestorsSelected(contractId)}
							onClick={() => selectAllProps.onContractSelectAll(contractId)}
						/>
						<span className="px-2">{props.column.label}</span>
					</div>
				</div>
			);
		} else {
			return (
				<DefaultColumnRenderer
					{...props}
					className={classNames('pl-4', {
						'text-left border-b border-solid border-gray-300 pr-4 pb-1':
							props.column.id === 'contracts',
					})}
				/>
			);
		}
	};
